import { ReactNode } from 'react';
import classNames from 'classnames';
import { Body1Strong, Caption1 } from '@fluentui/react-components';

type TProps = {
  label: string;
  /** Optional tailwind col-span classes (e.g. `md:col-span-2 lg:col-span-3`). */
  spanClass?: string;
  children: ReactNode;
};

/**
 * Stacked metadata cell: muted label on top, bolder value below.
 * Used inside the responsive field grids on the literature detail page
 * (Home tab content and Assessment cards). A shared cell keeps both views
 * visually consistent and removes duplicated markup.
 */
const FieldCell = ({ label, spanClass, children }: TProps) => (
  <div className={classNames('min-w-0', spanClass)}>
    <div className="mb-0.5 text-neutral-500">
      <Caption1>{label}</Caption1>
    </div>
    <div className="break-words force-break-word">
      <Body1Strong>{children}</Body1Strong>
    </div>
  </div>
);

export default FieldCell;
